import { render, staticRenderFns } from "./WidgetCurrentProject.vue?vue&type=template&id=3e0bc534&scoped=true"
import script from "./WidgetCurrentProject.vue?vue&type=script&lang=js"
export * from "./WidgetCurrentProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0bc534",
  null
  
)

export default component.exports